import {useState} from "react";
import Popup from "../../../../../../components/general/Popup.tsx";
import type {Transaction} from "../../../../entrepreneur/TransactionsTable.tsx";

interface Props {
    transaction: Transaction | null;
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => Promise<void>;
}

export function UndoBookAwayConfirmationModal({transaction, isOpen, onClose, onConfirm}: Props) {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const hasVatCode = Boolean(transaction?.vatCode);

    async function handleConfirm() {
        setIsSubmitting(true);
        setError(null);
        try {
            await onConfirm();
        } catch {
            setError("Het ongedaan maken van het wegboeken is mislukt. Probeer het opnieuw.");
        } finally {
            setIsSubmitting(false);
        }
    }

    return (
        <Popup
            open={isOpen}
            onClose={onClose}
            onConfirm={handleConfirm}
            title="Wegboeken ongedaan maken"
            variant="danger"
            confirmButtonDisplayLabel={isSubmitting ? "Bezig..." : "Ongedaan maken"}
            confirmButtonDisabled={isSubmitting}
        >
            <p className="text-sm text-gray-700">
                Weet je zeker dat je het wegboeken van deze transactie ongedaan wilt maken?
            </p>
            {hasVatCode && (
                <p className="mt-2 text-sm text-gray-700" data-testid="undo-vat-warning">
                    Deze transactie telt op dit moment mee in de BTW-aangifte van de bijbehorende periode. Als je het wegboeken ongedaan maakt, vervalt deze bijdrage.
                </p>
            )}
            {error && (
                <p className="mt-2 text-sm text-red-700" data-testid="undo-error">
                    {error}
                </p>
            )}
        </Popup>
    );
}
